import type { CmsProps } from '../../types/cms'

const FormattedImage = ({ image, responsive }: CmsProps) => {
  const dimensions = size =>
    image?.data?.attributes[size] /
    (image?.data?.attributes?.mime === 'image/svg+xml' ? 1.0 : 3.0)

  const attributes = image?.data?.attributes
  if (!attributes) return null

  return (
    <img
      src={attributes.url}
      width={dimensions('width')}
      height={dimensions('height')}
      alt={attributes.alternativeText ?? ''}
      style={responsive ? { width: '100%', height: 'auto' } : undefined}
    />
  )
}

export default FormattedImage
